import { AppState } from '@sweetspot/club-portal-legacy/store/types'

export const initialState: AppState = {
  toast: null,
  mode: 'club',
  isLoading: false,
}
